module.exports = __webpack_public_path__ + "img/publicScene.5d3cad1e.png";